import { useDroppable } from "@dnd-kit/core";
import type { Lead, LeadStage } from "../../lib/leads";
import { STAGE_COLORS } from "../../lib/leads";
import { LeadCard } from "./LeadCard";

interface KanbanColumnProps {
  stage: LeadStage;
  title: string;
  leads: Lead[];
  onMoveToStage: (idempotencyKey: string, stage: LeadStage) => void;
}

export function KanbanColumn({ stage, title, leads, onMoveToStage }: KanbanColumnProps) {
  const { isOver, setNodeRef } = useDroppable({ id: stage });

  return (
    <div
      ref={setNodeRef}
      className="kanban-column"
      style={{
        background: isOver ? "rgba(13,110,253,0.06)" : undefined,
        borderTop: `3px solid ${STAGE_COLORS[stage]}`,
      }}
    >
      <header className="kanban-column-header">
        {/* Round 6 polish audit (AUD-016): h2, not h3 — LeadsPage's own
            heading is now a real h1 ("Leads"), so this would otherwise skip
            a level (heading-order). */}
        <h2 style={{ color: STAGE_COLORS[stage] }}>{title}</h2>
        <span className="kanban-column-count">{leads.length}</span>
      </header>
      <div className="kanban-column-cards">
        {leads.map((lead) => (
          <LeadCard key={lead.idempotencyKey} lead={lead} onMoveToStage={onMoveToStage} />
        ))}
        {/* round9/design-pass: an empty column shows where a card would land,
            so an empty board reads as ready rather than broken. Decorative. */}
        {leads.length === 0 && <div className="kanban-empty-slot" aria-hidden="true" />}
      </div>
    </div>
  );
}
